import { replaceApostropheWithPrimeMarkAndRemoveSpace } from '@doltech/utils/lib/normalize';

export const getCheckCorrectAnswerFreeInput = (correctAnswer, userAnswer: string) => {
  const convertedUserAnswer = replaceApostropheWithPrimeMarkAndRemoveSpace(userAnswer);
  const convertedCorrectAnswer = replaceApostropheWithPrimeMarkAndRemoveSpace(correctAnswer);
  const correctAnswerToView = correctAnswer?.split('/')?.[0];

  const isMatch = convertedCorrectAnswer
    ?.split('/')
    .some(
      (eachCorrectAnswer) => eachCorrectAnswer.toLowerCase() === convertedUserAnswer?.toLowerCase()
    );

  return {
    correctAnswerToView,
    userAnswerToView: userAnswer?.trim(),
    isMatch,
  };
};
